<template>
  <w-settings-detail :title="title" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
    <component slot="activeView" :is="activeMenu"></component>
  </w-settings-detail>
</template>

<script>
import WSettingsDetail from '@/components/template/SettingsDetail';
import WVariableSetting from './VariableSetting';
import WTaskSetting from './TaskSetting';
import WJobSetting from './JobSetting';
import WTriggerSetting from './TriggerSetting';

const defaultMenu = 'WVariableSetting';
export default {
  name: 'WAmsSettings',
  components: {
    WSettingsDetail,
    WVariableSetting,
    WTaskSetting,
    WJobSetting,
    WTriggerSetting,
  },
  props: {
    title: String,
  },
  data() {
    return {
      defaultMenu,
      activeMenu: defaultMenu,
      menu: [
        {
          id: 'WVariableSetting',
          name: '변수 설정',
          active: false,
        },
        {
          id: 'WTaskSetting',
          name: '태스크 설정',
          active: false,
        },
        {
          id: 'WJobSetting',
          name: '작업 설정',
          active: false,
        },
        {
          id: 'WTriggerSetting',
          name: '템플릿 설정',
          active: false,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/AmsSettings/index.vue